import React from 'react';
import moment from 'moment';
import { isMobile } from 'react-device-detect';
import Link from '../components/Link/Link.js';

const strings = portalStrings;

export function addTelLinks(string, regex = /(\d{4} \d{3} \d{3})/gm) {
  const matches = string.match(regex);

  let ret = [];

  if (isMobile && matches) {
    ret = string.split(regex);

    ret.forEach((item, index) => {
      if (matches.indexOf(item) !== -1) {
        ret[index] = (
          <Link key={index} label={ret[index]} link={'tel:' + ret[index]} />
        );
      }
    });
  } else {
    ret = string;
  }

  return ret;
}

export function getString(component, value) {
  const string = strings[component][value];
  if (string) {
    return addTelLinks(string);
  } else {
    return '';
  }
}

export function getStringWithBreaks(component, value) {
  const string = strings[component][value];
  if (string) {
    return string.split('\n').map((item, index, { length }) => {
      let ret = [addTelLinks(item)];

      if (length - 1 !== index) {
        ret.push(<br key={index} />);
      }

      return ret;
    });
  } else {
    return '';
  }
}

export function stringToCamelCase(value) {
  return value
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function stringToDate(string) {
  return moment(new Date(string)).format('ddd, D MMM YYYY');
}

export function stringToDateCompact(string) {
  return moment(new Date(string)).format('DD/MM/YYYY');
}

export function stringToDateShort(string) {
  return moment(new Date(string)).format('D MMM YYYY');
}

export function stringToDateShortLeadingZero(string) {
  return moment(new Date(string)).format('DD MMM YYYY');
}

export function stringToDateTime(string) {
  return moment(new Date(string)).format('ddd, D MMM YYYY, h:mma');
}

export function stringToDayName(string) {
  return moment(new Date(string)).format('ddd');
}

export function stringToDay(string) {
  return moment(new Date(string)).format('D');
}

export function stringToMonth(string) {
  return moment(new Date(string)).format('MMM');
}

export function stringToYear(string) {
  return moment(new Date(string)).format('YY');
}

export function stringStripSpaces(string) {
  return string.replace(/\s/g, '');
}

export function stringToCurrency(string) {
  const formatter = new Intl.NumberFormat('en-NZ', {
    style: 'currency',
    currency: 'NZD',
    minimumFractionDigits: 2,
  });

  const amount = parseFloat(string);
  if (!isNaN(amount)) {
    return formatter.format(amount);
  }
  return '$0.00';
}

export function stringToTenancyStatus(string) {
  if (string == 'FOR') {
    string = 'Previous';
  }
  return string;
}

/* Add zero-width space to prevent iPhone bug where button label looks disabled even though it's enabled */
export function iPhoneFriendlyButtonLabel(label, disabled) {
  if (disabled) {
    return label + String.fromCharCode(8203);
  } else {
    return label;
  }
}

export function stripInvalidCharacters(data, valuesToStrip = null) {
  const regex = portalSettings.INVALID_CHARACTER_REGEX;
  if (regex) {
    if (typeof data === 'string') {
      data = data.replace(new RegExp(regex, 'gi'), '').trim();
    } else {
      valuesToStrip.forEach((element, key) => {
        data[element] = data[element].replace(new RegExp(regex, 'gi'), '');
      });
    }
  }
  return data;
}
